import { useMemo, useState, useCallback } from 'react';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

export const useSpacePersistentExpansion = ({
	sectionName,
	collapsedByDefault = false,
	forceExpand = false,
}) => {
	const [isExpandedManually, setIsExpandedManually] = useState<boolean | undefined>();

	const isDefaultExpanded = useMemo(
		() => getExpandedStateBySpace(sectionName, collapsedByDefault),
		[sectionName, collapsedByDefault],
	);

	const hasManualExpansion = isExpandedManually !== undefined;
	const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;

	const onExpansionToggle = useCallback(
		(newIsExpanded: boolean): void => {
			setIsExpandedManually(newIsExpanded);
			updateExpandedStateBySpace(sectionName, newIsExpanded);
		},
		[sectionName],
	);

	return {
		isExpanded,
		onExpansionToggle,
	};
};

const getExpandedStateBySpace = (sectionName: string, collapsedByDefault: boolean) => {
	if (
		localStorage &&
		localStorage.doesContain(PERSISTED_KEYS_ON_SERVER.PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)
	) {
		const sideNavExpansionStates = localStorage.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES,
		);
		if (typeof sideNavExpansionStates[sectionName] === 'boolean') {
			return sideNavExpansionStates[sectionName];
		}
	}
	return !collapsedByDefault;
};

const updateExpandedStateBySpace = (sectionName: string, isExpanded: boolean) => {
	if (!localStorage) {
		return;
	}
	const sideNavExpansionStates =
		localStorage.getItem(PERSISTED_KEYS_ON_SERVER.PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) ||
		{};
	localStorage.setItem(PERSISTED_KEYS_ON_SERVER.PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
		...sideNavExpansionStates,
		[sectionName]: isExpanded,
	});
};
